import {Shipment} from '../models/shipment';
import {DeliveredAt, TrackTrace, TransitState} from '../models/trackTrace';

const calculateShipmentTrackProgress = (
    shipment: Shipment,
    trackTrace: TrackTrace | null
): number => {
    if (shipment.isPendingAction || shipment.isPendingBackorder) {
        return 20;
    }

    if (!trackTrace && shipment.isShipped) {
        return 40;
    }

    if (!trackTrace) {
        return 40;
    }

    if (
        trackTrace.isInTransit &&
        trackTrace.transitState === TransitState.SORTING
    ) {
        return 60;
    }

    if (trackTrace.isInTransit || trackTrace.isFaulty) {
        return 80;
    }

    if (
        trackTrace.isDelivered &&
        (trackTrace.deliveredAt === DeliveredAt.AT_PICKUP_POINT ||
            trackTrace.deliveredAt === DeliveredAt.NEIGHBOURS)
    ) {
        return 80;
    }

    return 100;
};

export default calculateShipmentTrackProgress;
